/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var AdditionalEquipmentType;
(function (AdditionalEquipmentType) {
    AdditionalEquipmentType["Common"] = "Common";
    AdditionalEquipmentType["SpecificCar"] = "SpecificCar";
    AdditionalEquipmentType["CarTires"] = "CarTires";
})(AdditionalEquipmentType || (AdditionalEquipmentType = {}));
export function AdditionalEquipmentTypeFromJSON(json) {
    return AdditionalEquipmentTypeFromJSONTyped(json, false);
}
export function AdditionalEquipmentTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function AdditionalEquipmentTypeToJSON(value) {
    return value;
}
